import React from "react";
import PropTypes from "prop-types";
import styles from "./NotesModal.module.css";

export const NotesModal = ({ isOpen, onClose, date, headline, body, author }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modal_overlay}>
            <div className={styles.modal_container}>
                <div className={styles.modal_header}>
                    <h2 className={styles.modal_title}>Note</h2>
                    <button className={styles.close_button} onClick={onClose} aria-label="Close note">
                        ✕
                    </button>
                </div>
                <div className={styles.modal_content_wrapper}>
                <div className={styles.modal_content}>
                    <div className={styles.date}>{date}</div>
                    <div className={styles.divider}></div>
                    <h3 className={styles.headline}>{headline}</h3>
                    <p className={styles.body}>{body}</p>
                    <div className={styles.modal_footer}>
                        <span className={styles.author}>— {author}</span>
                    </div>
                </div>
                </div>
               
            </div>
        </div>
    );
};

NotesModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    date: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired
};
